export default __webpack_public_path__ + "static/N0230-d71a2cec40ef272419c62fc1b8b805e8.png";